<template>
    <div class="o-terms">
        <div class="o-terms__page">
            <h1 class="a-title">Regulamin</h1>
            <div class="o-terms__header">
                <p class="a-text a-text--center">
                    Przed przejściem dalej musisz zaakceptowac nasz regulamin:
                </p>
                <a
                    download="terms.title"
                    :href="terms.file_link"
                    class="a-button o-terms__button"
                    target="_blank"
                    >Pobierz regulamin</a
                >
            </div>
            <div class="o-terms__content">
                <form class="o-terms__form" @submit.prevent="handleSubmit">
                    <div class="o-terms__formItem">
                        <input
                            class="a-control"
                            type="checkbox"
                            name="terms"
                            id="terms"
                            required
                        />
                        <label class="o-terms__label" for="terms"
                            >Akceptuję regulamin</label
                        >
                    </div>
                    <div class="o-terms__formItem">
                        <button type="submit" class="a-button">
                            Przejdź dalej
                        </button>
                    </div>
                </form>
            </div>
            <div class="o-terms__footer">
                <button
                    class="a-button a-button--small a-button--grey"
                    @click="logout"
                >
                    Wyloguj
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        terms() {
            return this.$store.getters['termsAndConditions/terms']
        },
        isTermsAccepted() {
            return this.$store.getters['termsAndConditions/accepted']
        }
    },
    created() {
        this.$store.dispatch('termsAndConditions/fetchTerms')
    },
    methods: {
        handleSubmit() {
            this.$store.dispatch('termsAndConditions/acceptTerms').then(() => {
                this.$router.push({ name: 'dashboard' })
            })
        },
        logout() {
            this.$router.push({ name: 'logout' })
        }
    }
}
</script>
